import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { userSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

const params = {
  queryKey: [API_ENDPOINTS.USER_PROFILE],
  queryFn: () => get(API_ENDPOINTS.USER_PROFILE, userSchema),
}

export const useAPIGetUserProfile = () => useQuery(params)

export const useAPIGetUserProfileSuspense = () => useSuspenseQuery(params)
